export const stepComponentNames = {
  SignupStepEmail: "SignupStepEmail",
  SignupStepFullname: "SignupStepFullname",
  SignupStepReceipt: "SignupStepReceipt",
};
